export default __webpack_public_path__ + "static/media/train.88d845bd.svg";